/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventsResponse,
  getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventsResponse';

export type WorkspaceAuditEventsArgs = {
  /**
   * Organization scope; always validated against the caller's auth token.
   */
  organizationId?: string;

  /**
   * Inclusive lower bound of the time window. Must be <= now and <= end_time.
   */
  startTime?: string;

  /**
   * Inclusive upper bound of the time window. Defaults to now and must be <= now.
   */
  endTime?: string;

  /**
   * The maximum number of records to return per page; defaults to 50 and is capped server-side.
   */
  size?: number;

  /**
   * Opaque pagination cursor returned by a previous call; empty starts at the newest event.
   */
  cursor?: string;

  /**
   * Optional filter: discriminator of the audited action (e.g. "member.invited"). Empty disables.
   */
  eventType?: string;

  /**
   * Optional filter: stable user identifier of the principal who performed the action. Empty disables.
   */
  actorId?: string;

  /**
   * Optional filter: stable user identifier of the principal the action was performed on. Empty disables.
   */
  targetId?: string;

  /**
   * Optional filter: legal entity associated with the event. Empty disables.
   */
  legalEntityId?: string;

  /**
   * Optional filter: outcome of the audited action ("success" or "failure"). Currently only "failure" is queryable via a dedicated index; passing "success" returns InvalidArgument.
   */
  outcome?: string;

  /**
   * Optional filter: identifier grouping events emitted as part of the same batch action. Empty disables.
   */
  correlationId?: string;

  /**
   * Optional free-text search. Case-sensitive substring match against stored audit fields (event_type, event_id, actor_id, target_id, legal_entity_id, correlation_id, outcome). Combined with other filters as AND. Empty disables.
   */
  search?: string;
};

export type WorkspaceAuditEventsResult =
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventsResponse;

const validateWorkspaceAuditEventsResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: WorkspaceAuditEventsResult data does not match contract.`,
      errors,
    );
  }
};

export const getWorkspaceAuditEventsUrl = (
  params: WorkspaceAuditEventsArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (params.startTime !== null && params.startTime !== undefined) {
    const val = params.startTime;
    searchParams.append('start_time', `${val}`);
  }

  if (params.endTime !== null && params.endTime !== undefined) {
    const val = params.endTime;
    searchParams.append('end_time', `${val}`);
  }

  if (params.size !== null && params.size !== undefined) {
    const val = params.size;
    searchParams.append('size', `${val}`);
  }

  if (params.cursor !== null && params.cursor !== undefined) {
    const val = params.cursor;
    searchParams.append('cursor', `${val}`);
  }

  if (params.eventType !== null && params.eventType !== undefined) {
    const val = params.eventType;
    searchParams.append('event_type', `${val}`);
  }

  if (params.actorId !== null && params.actorId !== undefined) {
    const val = params.actorId;
    searchParams.append('actor_id', `${val}`);
  }

  if (params.targetId !== null && params.targetId !== undefined) {
    const val = params.targetId;
    searchParams.append('target_id', `${val}`);
  }

  if (params.legalEntityId !== null && params.legalEntityId !== undefined) {
    const val = params.legalEntityId;
    searchParams.append('legal_entity_id', `${val}`);
  }

  if (params.outcome !== null && params.outcome !== undefined) {
    const val = params.outcome;
    searchParams.append('outcome', `${val}`);
  }

  if (params.correlationId !== null && params.correlationId !== undefined) {
    const val = params.correlationId;
    searchParams.append('correlation_id', `${val}`);
  }

  if (params.search !== null && params.search !== undefined) {
    const val = params.search;
    searchParams.append('search', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/workspace/audit-events${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch WorkspaceAuditEvents
 * @Url /organization/v1/workspace/audit-events
 * @Auth Required
 */

export function useGetWorkspaceAuditEvents(
  params: WorkspaceAuditEventsArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): WorkspaceAuditEventsResult | undefined;

export function useGetWorkspaceAuditEvents(
  params: WorkspaceAuditEventsArgs,
  options?: FetchOptions,
): WorkspaceAuditEventsResult;

export function useGetWorkspaceAuditEvents(
  params: WorkspaceAuditEventsArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getWorkspaceAuditEventsUrl(params, options);
  const data = useFetch<WorkspaceAuditEventsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateWorkspaceAuditEventsResult(data);
  }

  return data;
}

/**
 * Access WorkspaceAuditEvents fetch callback
 */
export const useGetWorkspaceAuditEventsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: WorkspaceAuditEventsArgs, additionalHeaders?: Record<string, string>) => {
      const url = getWorkspaceAuditEventsUrl(params);
      const resource = getResource<WorkspaceAuditEventsResult>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateWorkspaceAuditEventsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh WorkspaceAuditEvents without throwing to suspense
 * @Url /organization/v1/workspace/audit-events
 * @Auth Required
 */
export const useRefreshWorkspaceAuditEvents = (
  params: WorkspaceAuditEventsArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getWorkspaceAuditEventsUrl(params);

  const { fetch } = useFetchableResource<WorkspaceAuditEventsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove WorkspaceAuditEvents from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/workspace/audit-events
 */
export const useClearWorkspaceAuditEvents = (params: WorkspaceAuditEventsArgs) => {
  const url = getWorkspaceAuditEventsUrl(params);

  const { clear } = useFetchableResource<WorkspaceAuditEventsResult>(url);

  return clear;
};

export const useWithOptimisticWorkspaceAuditEventsUpdates = (params: WorkspaceAuditEventsArgs) => {
  const url = getWorkspaceAuditEventsUrl(params);

  const { optimisticUpdate } = useFetchableResource<WorkspaceAuditEventsResult>(url);

  return optimisticUpdate;
};
